"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMediaLinkDef = exports.fromMediaLink = exports.MediaLinkDef = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
exports.MediaLinkDef = t.strict({
    select: t.literal("media"),
});
function fromMediaLink(link) {
    var _a;
    if ("media" !== ((_a = link.config) === null || _a === void 0 ? void 0 : _a.select))
        return;
    return {
        select: "media",
    };
}
exports.fromMediaLink = fromMediaLink;
function defaultMediaLinkDef() {
    return {
        select: "media",
    };
}
exports.defaultMediaLinkDef = defaultMediaLinkDef;
